<div class="bodyScroll">
    <!-- <div class="row mt-2 ml-5 mr-5 padding" style="justify-content: center;">
        <div class="col-md-4 p-2 link-cursor"  >
            <mat-card class="card card1 w-100 m-0 p-2">
                <div class="spaceBtwn px-2 col-md-12">
                    <div class="d-flex font14">                        
                        <img [src]="'assets/icons/total.svg'" class="cardicon zoom" alt="Unprocessed"> Total incidents
                    </div>

                    <div class="cardlbl">
                        {{total }}
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="col-md-4 p-2 link-cursor"  >
            <mat-card class="card card2 w-100 m-0 p-2">
                <div class="spaceBtwn px-2 col-md-12">
                    <div class="d-flex font14">                        
                        <img [src]="'assets/icons/open.svg'" class="cardicon zoom" alt="Unprocessed"> Open incidents
                    </div>

                    <div class="cardlbl">
                        {{ open}}
                    </div>
                </div>
            </mat-card>
        </div>
        <div class="col-md-4 p-2 link-cursor"  >
            <mat-card class="card card3 w-100 m-0 p-2">
                <div class="spaceBtwn px-2 col-md-12">
                    <div class="d-flex font14">                        
                        <img [src]="'assets/icons/AverageTime.svg'" class="cardicon zoom" alt="Unprocessed"> Average resolution time
                    </div>

                    <div class="cardlbl">
                        {{average + " Hrs" }}
                    </div>
                </div>
            </mat-card>
        </div>        
    </div> -->
    
    
    <!-- <div class="row">
        <div class="col-md-4 p-2 link-cursor" *ngFor="let kpi of kpiData">
          <mat-card class="card card3 w-100 m-0 p-2">
            <div class="spaceBtwn px-2 col-md-12">
              <div class="d-flex font14">
                <img [src]="getImageUrl(kpi.displayText)" class="cardicon zoom" alt="{{kpi.displayText}}">
                {{ kpi.displayText }}
              </div>
              <div class="cardlbl">
                {{ kpi.count }}
              </div>
            </div>
          </mat-card>
        </div>
      </div> -->    
      <div class="mttop">
        <app-kpi-configuration></app-kpi-configuration>
      </div>   
    <div class="row col-md-12 ml-3 pr-5 expandedStyle">
        <div class="col-md-6 m-0 px-2">
            <div class="tp-box w-100" [@flipState]="flip1">
                <div class="tp-box__side tp-box__front card dashboardCardStyle">
                    <div class="card-header headre-card mat-subheading-2 pl-3">
                        <div>Incident volume (last 3 months)</div>
                        <a class="rotate-btn" (click)="toggleFlip1()">View table</a>
                    </div>
                    <div class="card-body">
                        <!-- <div class="paddingleft"> -->
                            <div class="pt-4 chart-container contentCenter col">
                                <!-- <canvas class="canvasstylechart" id="linechart">{{ chart }}</canvas> -->
                                <app-common-chart 
                                [chartId]="'linechart'" 
                                [chartType]="'line'" 
                                [labels]="dashboardReportData.incidentsByWeeks" 
                                [datasets]="[
                                  { label: 'Incident timeline', data: dashboardReportData.totalIncidentsByWeeks, borderColor: '#FF6384', fill: false }
                                ]">
                              </app-common-chart>
                            </div>
                        <!-- </div> -->
                    </div>
                </div>
                <div class="tp-box__side tp-box__back card dashboardCardStyle">

                    <div class="card-header headre-card mat-subheading-2 pl-3">
                        <div>Incident volume (last 3 months)</div>
                        <a class="rotate-btn" (click)="toggleFlip1()">View chart</a>
                    </div>
                    <div class="card-body">
                        <!-- <div class="borderRadBtm"> -->                            
                            <!-- <div class="example-container p-0 tblbord"> -->
                            <table mat-table [dataSource]="dataSource1" class="mat-elevation-z8 custom-table">
                                <ng-container matColumnDef="incident">
                                    <th mat-header-cell *matHeaderCellDef class="tblHeader"> Incidents by weeks </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.incidentsByWeeks }} </td>
                                </ng-container>
                                <ng-container matColumnDef="incidentCount">
                                    <th mat-header-cell *matHeaderCellDef class="tblHeader"> Incidents created that week </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.totalIncidentsByWeeks }} </td>
                                </ng-container>                                

                                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-row"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
                            </table>
                        <!-- </div> -->
                        <div class="w-100 paginateStyle ">
                            <mat-paginator #timelinePaginator [pageSize]="5" class="" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 m-0 px-2 ">
            <div class="tp-box w-100" [@flipState]="flip2">
                <div class="tp-box__side tp-box__front card dashboardCardStyle">

                    <div class="card-header headre-card mat-subheading-2 pl-3">
                        <div>Incident status</div>
                        <a class="rotate-btn" (click)="toggleFlip2()">View table</a>
                    </div>
                    <div class="card-body">
                        <!-- <div class="paddingleft"> -->
                            <div class="pt-4 chart-container contentCenter col">
                                <!-- <h2 class="ml-3">Open/Closed incidents</h2> -->
                                <!-- <canvas class="canvasstylechart" id="horizontalbarchart">{{ chart }}</canvas> -->
                                <app-common-chart 
                                [chartId]="'horizontalbarchart'" 
                                [chartType]="'bar'" 
                                [labels]="OpenClosedLabels" 
                                [datasets]="[
                                  { label: 'Open incidents', data: OpenIncidentsData, borderColor: '#FF6384', barPercentage: 1, fill: false },
                                  { label: 'Closed incidents', data: ClosedIncidentsData, borderColor: '#36A2EB', barPercentage: 1, fill: false },
                                ]">
                              </app-common-chart>
                            </div>
                        <!-- </div> -->
                    </div>
                </div>
                <div class="tp-box__side tp-box__back card dashboardCardStyle">
                    <div class="card-header headre-card mat-subheading-2 pl-3">
                        <div>Incident status</div>
                        <a class="rotate-btn" (click)="toggleFlip2()">View chart</a>
                    </div>
                    <div class="card-body">
                        <div class="borderRadBtm">
                            <table mat-table [dataSource]="dataSource2" class="mat-elevation-z8">
                                <ng-container matColumnDef="column11">
                                    <th mat-header-cell *matHeaderCellDef class="tblHeader"> Incident name </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.businessProcessNames }} </td>
                                </ng-container>
                                <ng-container matColumnDef="column22">
                                    <th mat-header-cell *matHeaderCellDef class="tblHeader"> Open incidents </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.totalOpenIncidentsArray }} </td>
                                </ng-container>
                                <ng-container matColumnDef="column33">
                                    <th mat-header-cell *matHeaderCellDef class="tblHeader"> Closed incidents </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.closedIncidentsArray }} </td>
                                </ng-container>                               

                                <tr mat-header-row *matHeaderRowDef="displayedColumns1" class="table-row"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns1;" class="table-row"></tr>
                            </table>
                        </div>
                        <div class="w-100 paginateStyle ">
                            <mat-paginator #incidentsPaginator [pageSize]="5" class="" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- <div class="margintop"> -->
        <div class="row col-md-12 ml-3 pr-5  margintop expandedStyle">
            <div class="col-md-6 m-0 px-2">
                <div class="tp-box w-100" [@flipState]="flip3">
                    <div class="tp-box__side tp-box__front card dashboardCardStyle">
                        <div class="card-header headre-card mat-subheading-2 pl-3">
                            <div>Incident severity</div>
                            <a class="rotate-btn" (click)="toggleFlip3()">View table</a>
                        </div>                        
                        <div class="card-body">
                            <!-- <div class="paddingleft"> -->
                                <div class="pt-4 chart-container contentCenter col">
                                    <app-common-chart 
                                      [chartId]="'pie'" 
                                      [chartType]="'pie'" 
                                      [labels]="['Minor severity', 'Major severity']" 
                                      [datasets]="[
                                        { 
                                          data: [businessProcessSeverityData.SeverityMinorCount, businessProcessSeverityData.SeverityMajorCount], 
                                          backgroundColor: [ '#36A2EB','#FF6384'] 
                                        }
                                      ]">
                                    </app-common-chart>
                                  </div>
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="tp-box__side tp-box__back card dashboardCardStyle">
                        <div class="card-header headre-card mat-subheading-2 pl-3">
                            <div>Incident severity</div>
                            <a class="rotate-btn" (click)="toggleFlip3()">View chart</a>
                        </div>
                        <div class="card-body">
                            <div class="borderRadBtm">
                                <table mat-table [dataSource]="SeveritydataSource" class="mat-elevation-z8">
                                    <ng-container matColumnDef="BPName">
                                        <th mat-header-cell *matHeaderCellDef class="tblHeader"> Business process name</th>
                                        <td mat-cell *matCellDef="let element"> {{ element.businessProcessName }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="severityType">
                                        <th mat-header-cell *matHeaderCellDef class="tblHeader"> Minor severity</th>
                                        <td mat-cell *matCellDef="let element"> {{ element.minorCount }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="severityCount">
                                        <th mat-header-cell *matHeaderCellDef class="tblHeader"> Major severity</th>
                                        <td mat-cell *matCellDef="let element"> {{ element.majorCount }} </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns3" class="table-row"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns3;" class="table-row"></tr>
                                </table>
                            </div>
                            <div class="w-100 paginateStyle ">
                                <mat-paginator #severityPaginator [pageSize]="5" class="" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 m-0 px-2">
                <div class="tp-box w-100" [@flipState]="flip4">
                    <div class="tp-box__side tp-box__front card dashboardCardStyle">
                        <div class="card-header headre-card mat-subheading-2 pl-3">
                            <div>Incident Aging Overview</div>
                            <a class="rotate-btn" (click)="toggleFlip4()">View table</a>
                        </div>
                        <div class="card-body">
                            <!-- <div class="paddingleft"> -->
                                <div class="pt-4 chart-container contentCenter col" >
                                    <!-- <canvas class="canvasstylechart " id="barchart">{{ chart }}</canvas> -->
                                    <app-common-chart 
                                    [chartId]="'barchart'" 
                                    [chartType]="'bar'" 
                                    [labels]="businessProcessSeverityData.businessProcessNamesforAge" 
                                    [datasets]="[
                                      { label: '< 1 month', data: businessProcessSeverityData.data0to30days, borderColor: '#FF6384', barPercentage: 1, fill: false },
                                      { label: '1 - 2 months', data: businessProcessSeverityData.data31to60days, borderColor: '#36A2EB', barPercentage: 1, fill: false },
                                      { label: 'Older', data: businessProcessSeverityData.dataothers, borderColor: '#FFCE56', barPercentage: 1, fill: false },
                                    ]">
                                  </app-common-chart>
                                </div>
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="tp-box__side tp-box__back card dashboardCardStyle">
                        <div class="card-header headre-card mat-subheading-2 pl-3">
                            <div>Incident Aging Overview</div>
                            <a class="rotate-btn" (click)="toggleFlip4()">View chart</a>
                        </div>
                        <div class="card-body">
                            <div class="borderRadBtm">
                                <table mat-table [dataSource]="IncidentAgedataSource" class="mat-elevation-z8">
                                    <ng-container matColumnDef="incidentName">
                                        <th mat-header-cell *matHeaderCellDef class="tblHeader"> Incident name </th>
                                        <td mat-cell *matCellDef="let element"> {{ element.businessProcessNamesforAge }}
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="0to30days">
                                        <th mat-header-cell *matHeaderCellDef class="tblHeader"> < 1 month
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{ element.data0to30days }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="31to60days">
                                        <th mat-header-cell *matHeaderCellDef class="tblHeader"> < 2 months
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{ element.data31to60days }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="others">
                                        <th mat-header-cell *matHeaderCellDef class="tblHeader"> Older than 2 months
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{ element.dataOthers }} </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns2" class="table-row"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns2;" class="table-row">
                                    </tr>
                                </table>
                            </div>
                            <div class="w-100 paginateStyle ">
                                <mat-paginator #ageingPaginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25,100]"></mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="mt-5">
            <P></P>
            <br>
        </div>    
</div>




